import React, { useState } from "react";
import "./GuideCard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import Common from "../../../Common/Common";
import { useSelector } from "react-redux";
import ReviewsDialog from "../ReviewsDialog";
import GuideEditModal from "../GuideEditModal";
import { smallCover } from "../../../Common/coverThumb";

const icoStar     = solid("star");
const icoInfo     = solid("circle-info");
const icoCheck    = solid("check");
const icoDownload = solid("download");
const icoTrash    = solid("trash");
const icoClone    = solid("clone");
const icoRemove   = solid("eye-slash");

const GuideCard = (props) => {
  let user_info = useSelector((state) => state.user_info);
  const [ReviewsDialogShow, setReviewsDialogShow] = useState(false);
  const [GuideEditModalShow, setGuideEditModalShow] = useState(false);
  const [InfoCall, setInfoCall] = useState(false);

  // A 96 px card: the thumbnail, or a shrunk cover (Common/coverThumb.js, 2026-11-04) — it loaded the full cover.
  const getImageURLString = (photo, photo_m) => {
    let str = smallCover(photo, photo_m);
    let img = Common.getImageURL(str, Common.getFBPath(window.guide_obj.guide_id, user_info), false);
    return img;
  };

  const downloadGuide = () => {
    if (InfoCall) {
      setInfoCall(false);
      return;
    }
    if (props.callback !== null) props.callback(props.id, props.guide_info.guide_id, props.name);
    if (props.type !== "component") props.onHide();
  };

  const deleteGuide = (e) => {
    e.stopPropagation();
    if (props.delete_callback !== null) props.delete_callback(props.id, props.guide_info.guide_id);
  };

  const CopyFromGuide = (e) => {
    e.stopPropagation();
    if (props.copy_callback !== null) props.copy_callback(props.id, props.guide_info.guide_id);
  };

  const GuideInfo = (e) => {
    setInfoCall(true);
    e.stopPropagation();
    setGuideEditModalShow(true);
  };

  const showReviews = (e) => {
    e.stopPropagation();
    setReviewsDialogShow(true);
  };

  const fmt = (n) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return (
    <div className="gc-card" title="Select Guide" onClick={downloadGuide}>
      <div className="gc-image-well">
        <img
          src={getImageURLString(props.image, props.image_m)}
          className="gc-image"
          loading="lazy"
          decoding="async"
          referrerPolicy="no-referrer"
          alt=""
        />
      </div>

      <div className="gcard-body">
        <p className="gc-name">{props.name}</p>

        <div className="gc-meta-row">
          <span className="gc-meta-label">Language</span>
          <span className="gc-meta-value">{props.language}</span>
        </div>
        <div className="gc-meta-row">
          <span className="gc-meta-label">Countries</span>
          <span className="gc-meta-value">{Common.shortenText(props.countries.join(", "), 40)}</span>
        </div>
        <div className="gc-meta-row">
          <span className="gc-meta-label">Cities</span>
          <span className="gc-meta-value">{Common.shortenText(props.cities.join(", "), 40)}</span>
        </div>
        <div className="gc-meta-row">
          <span className="gc-meta-label">Access</span>
          <span className="gc-meta-value">{props.access}</span>
        </div>

        <div className="gc-stats-row">
          <div className="gc-stat-item">
            <span className="gc-stat-label">Rating</span>
            <span className="gc-stat-value">
              <FontAwesomeIcon icon={icoStar} className="gc-star" />
              {props.rating.toFixed(2)}
            </span>
          </div>
          <button
            className="gc-stat-item gc-stat-item--btn"
            onClick={showReviews}
          >
            <span className="gc-stat-label">Reviews</span>
            <span className={"gc-stat-value" + (props.reviews > 0 ? " gc-stat-value--link" : "")}>
              {fmt(props.reviews)}
            </span>
          </button>
          <div className="gc-stat-item">
            <span className="gc-stat-label">Read</span>
            <span className="gc-stat-value">{fmt(props.read)}</span>
          </div>
        </div>

        {/* Icon order matches andiamo-places' guide card action row: primary
            action (Select/Download) → Info → Copy → Delete. */}
        <div className="gc-footer-row">
          {props.mode === "list" && (
            <button
              className="gc-icon-btn gc-action-btn"
              title="Select Guide"
              onClick={(e) => { e.stopPropagation(); downloadGuide(); }}
            >
              <FontAwesomeIcon icon={icoCheck} />
            </button>
          )}

          {props.mode === "download" && (
            <button
              className="gc-icon-btn gc-action-btn"
              title="Download Guide"
              onClick={(e) => { e.stopPropagation(); downloadGuide(); }}
            >
              <FontAwesomeIcon icon={icoDownload} />
            </button>
          )}

          <button className="gc-icon-btn" title="Guide Info" onClick={GuideInfo}>
            <FontAwesomeIcon icon={icoInfo} />
          </button>

          {/* Gated on copy_callback actually being supplied, not on `type`
              (which otherwise means "embedded panel vs. popup dialog" for
              downloadGuide's auto-close and the two different delete-button
              behaviors below) — the desktop popup dialog never passed
              type="component" and previously had no copy_callback at all,
              so this button could never appear there regardless of type.
              Decoupling it lets any caller opt in just by providing the
              callback, without touching type's other meanings. Found
              2026-09-24. */}
          {props.copy_callback && !(props.access || "").includes("Read") && (
            <button
              className="gc-icon-btn gc-action-btn"
              title="Copy from Guide"
              onClick={CopyFromGuide}
            >
              <FontAwesomeIcon icon={icoClone} />
            </button>
          )}

          {/* Shared tab (4.10.55): a guide someone shared with you can be
              removed from your Library — it isn't deleted for its owner. */}
          {props.remove_callback && (
            <button
              className="gc-icon-btn gc-delete-btn"
              title="Remove from my Library"
              aria-label="Remove from my Library"
              onClick={(e) => { e.stopPropagation(); props.remove_callback(props.id, props.name); }}
            >
              <FontAwesomeIcon icon={icoRemove} />
            </button>
          )}

          {!props.remove_callback && props.type !== "component" && props.mode === "download" && (
            <button
              className="gc-icon-btn gc-delete-btn"
              title="Delete Guide"
              onClick={deleteGuide}
            >
              <FontAwesomeIcon icon={icoTrash} />
            </button>
          )}

          {!props.remove_callback && props.type === "component" && props.guide_info.user_id === user_info.uid && (
            <button
              className="gc-icon-btn gc-delete-btn"
              title="Delete Guide"
              onClick={deleteGuide}
            >
              <FontAwesomeIcon icon={icoTrash} />
            </button>
          )}
        </div>
      </div>

      {ReviewsDialogShow && (
        <ReviewsDialog show={ReviewsDialogShow} onHide={setReviewsDialogShow} id={props.id} />
      )}
      {GuideEditModalShow && (
        <GuideEditModal
          show={GuideEditModalShow}
          onHide={() => setGuideEditModalShow(false)}
          guide_info={props.guide_info}
          guide_info_id={props.id}
          user_info={user_info}
          mode={"VIEW"}
        />
      )}
    </div>
  );
};

export default GuideCard;
